// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__15LM-","CookieConsent":"App_CookieConsent__1yUIN","CookieText":"App_CookieText__1sbqp","CookieButton":"App_CookieButton__3cvqF"};